export default __webpack_public_path__ + "static/media/red-dot.a37608da.svg";